import React, { SVGProps } from 'react';
import clsx from 'clsx';

import styles from './IconButton.module.scss';

export type IconButtonProps = {
  //icon?: string;
  iconComponent: React.ReactNode;
  disabled?: boolean;
  //iconClassName?: string;
  testId?: string;
  tooltip?: string;
  // e.g. in IconDropDownButton we need to enable click propagation,
  // so that useTriggerOnClickOutsideElement works.
  // by default click propagation is disabled (so that the button works correctly in tables, e.g. MergeFieldList
  enableClickPropagation?: boolean;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const IconButton = React.forwardRef<HTMLAnchorElement, IconButtonProps>(
  function IconButton(props, ref) {
    const {
      //icon,
      iconComponent,
      disabled,
      testId,
      className,
      onClick,
      enableClickPropagation,
      //iconClassName,
      tooltip,
      ...restProps
    } = props;

    return (
      <a
        {...restProps}
        ref={ref}
        data-disabled={disabled}
        className={clsx(styles.iconButton, className)}
        data-test-id={testId}
        title={tooltip}
        onClick={
          enableClickPropagation
            ? onClick
            : (e) => {
                e.stopPropagation();
                onClick?.(e);
              }
        }
      >
        {props.iconComponent}
      </a>
    );
  },
);
/*
{props.iconComponent ? (
          props.iconComponent
        ) : props.icon ? (
          <img className={clsx(styles.image, iconClassName)} src={icon} />
        ) : null}
*/
